import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import './EarningruleListWithType.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { ActionsDropdownForItem } from 'components/base/ActionsDropdown';
import CustomEditableRank from 'components/base/CustomEditableRank';
import CustomLinkableName from 'components/base/CustomLinkableName';
import CustomListCheckbox from 'components/base/CustomListCheckbox';
import 'components/base/CustomListComponent.scss';
import CustomPagination from 'components/base/CustomPagination';
import CustomRichTextViewer from 'components/base/CustomRichTextViewer';
import { CustomStatusTagFromText } from 'components/base/CustomStatusTag';
import DeletePrompt from 'components/base/DeletePrompt';
import DisplayOrderTableData from 'components/base/DisplayOrderTableData';
import LabelWithToolTips from 'components/base/LabelWithToolTips';
import Loading from 'components/base/Loading';
import NoDataPage from 'components/base/NoDataPage';
import { SortableTableBody } from 'components/base/SortableTable';
import PreviewImage from 'components/base/prompt/PreviewImage';
import {
  APIStatus,
  LanguageConfig,
  MessageTag,
  StatusTag,
} from 'config/CustomEnums';
import QRCodeCollapse from 'containers/merchants/stores/QRCodeCollapse';

import { checkHasPermission, createAction } from 'utils';

import './BaseListContainer.scss';

// import { URLFilterKeys } from '../CampaignUrlConfig';

function checkHasField(fields, name) {
  for (let i = 0; i < fields?.length; i++) {
    if (fields[i].displayName === name) {
      return true;
    }
  }
  return false;
}

function getCommonFieldsCount(fields) {
  let count = 0;

  for (let i = 0; i < fields.length; i++) {
    if (
      ['ID', 'Name', 'Name (preferred name)', 'Status'].indexOf(
        fields[i].displayName,
      ) < 0
    ) {
      count = count + 1;
    }
  }

  return count;
}

function BaseListContainer(props) {
  const [checkedList, setCheckedList] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const dataList = props.dataList || [];

  const {
    totalPage,
    model,
    fields = [],
    deleteInfo,
    customActions,
    extraRankStyle,
    hasOtherActions,
    actions = ['Edit', 'Detail', 'Delete'],
    actionDispatchType = {},
    sortable = false,
    onSortEnd,
    permissionGroup,
    customPermissionMap = {}, // e.g. {add: "add_campaign", change: ...,view: ..., delete: ... }
    onOrderChangedByEdit,
    showTableLeftShadow = true,
    showTableRightShadow = true,
    sortDisabled,
    openNewTab = false,
    customPathname = '',
    customPathId = '',
  } = props;
  const pushPathname = customPathname || location.pathname;
  const pushPathId = customPathId || 'pk';
  const hideActions = props.hideActions || false;
  const useCustomCommonActions = props.useCustomCommonActions;
  const customCommonActions = props.customCommonActions || (() => { });
  const customClassName = props.customClassName || '';
  const queryString = require('query-string');
  const { status } = useSelector((state) => {
    // console.log('@@48: ', state.earningRuleList.earningRuleTypeList);
    return {
      status: state.loading.status,
    };
  });

  const addPermission = customPermissionMap?.add || `add_${permissionGroup}`
  const viewPermission = customPermissionMap?.view || `view_${permissionGroup}`
  const changePermission = customPermissionMap?.change || `change_${permissionGroup}`
  const deletePermission = customPermissionMap?.delete || `delete_${permissionGroup}`
  const publishPermission = customPermissionMap?.publish || `publish_${permissionGroup}`
  const unpublishPermission = customPermissionMap?.unpublish || `unpublish_${permissionGroup}`
  
  const [showPrompt, setShowPrompt] = useState(false);
  const [operatedItem, setOperatedItem] = useState();
  const [tableStartReach, setTableStartReach] = useState(true);
  const [tableEndReach, setTableEndReach] = useState(false);
  const searchQuery = queryString.parse(location.search);
  const searchQueryKeyList = Object.keys(searchQuery);
  const searchQueryKeyListEmptyOrOnlyPage =
    searchQueryKeyList.length <= 0 ||
    (searchQueryKeyList.length === 1 && searchQueryKeyList[0] === 'page');

  const currentPage = searchQuery['page']
    ? parseInt(searchQuery['page']) - 1
    : 0;
  const [enlargeImage, setEnlargeImage] = useState();

  const { user, languages } = useSelector((state) => ({
    user: state.users,
    languages: state.language.allList,
  }));

  useEffect(() => {
    setCheckedList([]);
    dispatch({
      type: `${model}/updateState`,
      payload: { checkedList: [] },
    });
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const AllActions = [
    {
      name: 'Edit',
      action: (item) => {
        dispatch({ type: `${model}/clearData` });
        return history.push(`${pushPathname}/${item[pushPathId]}/edit/`);
      },
      requires: changePermission,
    },
    {
      name: 'Detail',
      action: (item) => {
        dispatch({ type: `${model}/clearData` });
        return history.push(`${pushPathname}/${item[pushPathId]}/`);
      },
      requires: viewPermission,
    },
    {
      name: 'Delete',
      action: (item) => {
        setOperatedItem(item);
        setShowPrompt(true);
      },
      requires: deletePermission,
    },
    {
      name: 'Duplicate',
      action: (item) => {
        dispatch(
          createAction(actionDispatchType?.duplicate || `${model}/duplicate`)({
            data: item,
            afterAction: () => history.push(location),
          }),
        );
      },
      requires: addPermission,
    },
  ];

  const getNormalActions = (item) => {
    let filteredActions = AllActions.filter((val) =>
      actions.includes(val.name),
    );
    if (item.status) {
      switch (item.status) {
        case MessageTag.sent:
        case MessageTag.sending:
        case MessageTag.error:
          filteredActions = filteredActions.filter(
            (val) => val.name !== 'Edit',
          );
          break;
        case StatusTag.deleteRequested:
          filteredActions = filteredActions.filter(
            (val) => val.name === 'Detail',
          );
          break;
        // case StatusTag.preActive:
        //   filteredActions = filteredActions.filter(
        //     (val) => val.name !== 'Edit',
        //   );
        //   break;
        default:
          break;
      }
    }
    if (item.defaultSegment) {
      filteredActions = filteredActions.filter((val) => val.name === 'Detail');
    }
    return filteredActions;
  };

  const otherActions = (data) => {
    if (data.status === StatusTag.deleteRequested) {
      return null;
    }
    if (!hasOtherActions) {
      return null;
    }
    if (data?.status === StatusTag.preActive) {
      return null;
    }

    let actions = [];
    if (customActions.deactive) {
      actions.push({
        name: `${[
          StatusTag.active,
          StatusTag.activeRequired,
          StatusTag.temporary,
          StatusTag.temporaryEarning,
        ].includes(data.status)
          ? 'Deactive'
          : 'Active'
          }`,
        action: (item) => {
          console.log('create action to deactive item: ', item);
          customActions.deactive(item);
        },
        requires: changePermission,
      });
    }

    if (customActions.moveToFirst) {
      actions.push({
        name: 'Move to first',
        action: (item) => {
          customActions.moveToFirst(item);
        },
        requires: changePermission,
      });
    }

    if (customActions.moveToLast) {
      actions.push({
        name: 'Move to last',
        action: (item) => {
          customActions.moveToLast(item);
        },
        requires: changePermission,
      });
    }

    if (customActions.publish) {
      actions.push({
        name: 'Publish',
        action: (item) => {
          customActions.publish(item);
        },
        requires: publishPermission,
      });
    }

    if (customActions.unpublish) {
      actions.push({
        name: 'UnPublish',
        action: (item) => {
          customActions.unpublish(item);
        },
        requires: unpublishPermission,
      });
    }

    if (customActions.copyUrl) {
      languages.forEach((languageItem) => {
        actions.push({
          name: `Copy Url ${languageItem.name}`,
          action: (item) => {
            customActions.copyUrl(item, languageItem.code);
          },
        });
      });
    }

    if (customActions.custom) {
      if (typeof customActions.custom === 'function') {
        customActions.custom(data) && actions.push(customActions.custom(data));
      } else {
        actions.push(customActions.custom);
      }
    }

    return actions;
  };

  const stringSort = queryString.parse(location.search)['sort'] || '';
  let sorts = [];
  if (typeof stringSort === 'string' && stringSort) {
    sorts = stringSort.split(',');
  }

  const orientationForSort = (columnName) => {
    const sortKey = sorts.find((sort) => sort.includes(columnName));
    if (!sortKey || !sortKey?.includes('-')) {
      return false;
    }
    return true;
  };

  function iterate(relate, newSorts) {
    const otherSearchIndex = newSorts.findIndex((item) => relate === item);
    newSorts.splice(otherSearchIndex, 1);
  }

  const reDefineSort = (columnName, relatedOrderField) => {
    let newSorts = sorts?.filter((item) => item.length > 0) || [];
    const sortIndex = newSorts.findIndex((sort) => sort.includes(columnName));
    const sort = newSorts[sortIndex];
    if (sortIndex > -1) {
      newSorts.splice(sortIndex, 1);
    }
    if (relatedOrderField && relatedOrderField.length > 0) {
      relatedOrderField.forEach((item) => iterate(item, newSorts));
      newSorts.unshift(...relatedOrderField);
    }
    if (sort?.includes('-')) {
      newSorts.unshift(columnName);
    } else {
      newSorts.unshift(`-${columnName}`);
    }
    return newSorts.toString();
  };

  const checkAll = () => {
    let list = dataList;
    if (dataList.length === checkedList.length) {
      list = [];
    }
    dispatch({
      type: `${model}/updateState`,
      payload: { checkedList: list },
    });
    setCheckedList(list);
  };

  const itemCheck = (item) => {
    const list = [];
    let processed = false;
    checkedList.forEach((checkedItem) => {
      if (checkedItem.pk !== item.pk) {
        list.push(checkedItem);
      } else {
        processed = true;
      }
    });
    if (!processed) {
      list.push(item);
    }
    setCheckedList(list);
    dispatch({
      type: `${model}/updateState`,
      payload: { checkedList: list },
    });
  };

  const fieldClassName = (fieldName) => {
    let className = '';
    switch (fieldName) {
      case 'ID':
        className = 'rank-area-medium-width';
        break;
      case 'Name':
      case 'Name (preferred name)':
      case 'Campaign name':
        className = 'common-area-large-width';
        break;
      case 'Description':
      case 'Linked Campaign':
      case 'Related Store':
      case 'Subcategory':
      case 'Sub-category':
      case 'Assigned product subcategory':
      case "Linked physical store's product category":
      case "Linked physical store's product subcategory":
      case "Linked online store's product category":
      case "Linked online store's product subcategory":
      case 'Remark':
      case 'Permission':
        className = 'common-area-xlarge-width';
        break;
      default:
        className = `common-area-medium-width`;
        break;
    }

    return className;
  };
  const getTableTitles = () => {
    return (
      <tr>
        <th key={0}>
          <CustomListCheckbox
            checked={
              checkedList.length && checkedList.length === dataList.length
            }
            onChange={() => checkAll()}
          />
        </th>
        {fields.map((item, index) => {
          if (item.hide) {
            return null;
          };

          if (item.orderField) {
            return (
              <th key={index + 1} className={fieldClassName(item.displayName)}>
                <CustomEditableRank
                  rank={orientationForSort(item.orderField)}
                  show={
                    searchQuery['sort']?.indexOf(item.orderField) >= 0 ||
                    (item.orderField === 'displayPriority' &&
                      searchQueryKeyListEmptyOrOnlyPage)
                  }
                  title={item.displayName}
                  extraAreaStyle={'base-rank-container'}
                  extraRankStyle={extraRankStyle}
                  onClick={(rank) => {
                    history.push({
                      pathname: location.pathname,
                      hash: location.hash,
                      search: queryString.stringify({
                        ...queryString.parse(location.search),
                        ...{
                          page: 1,
                          rank: rank,
                          sort: reDefineSort(
                            item.orderField,
                            item.relatedOrderField,
                          ),
                        },
                      }),
                    });
                  }}
                />
              </th>
            );
          }

          return (
            <th key={index + 1} className={fieldClassName(item.displayName)}>
              <div
                className={`all-list-scrollable-area-table-item-common all-list-scrollable-area-title `}
              >
                {item.displayName}
              </div>
            </th>
          );
        })}
        {hideActions ? null : (
          <th key={fields.length + 2} className="common-action-area">
            <div
              className={`all-list-scrollable-area-table-item-common all-list-scrollable-area-title all-list-scrollable-area-action-title`}
            >
              Action
            </div>
          </th>
        )}
      </tr>
    );
  };

  const renderRowData = (item) => {
    return (
      <tr>
        <td className="all-list-scrollable-area-checkbox-container">
          <CustomListCheckbox
            disabled={item?.defaultSegment}
            checked={
              checkedList.find((checkedItem) => checkedItem.pk === item.pk) !==
              undefined
            }
            onChange={() => itemCheck(item)}
          />
        </td>
        {fields.map((field, index) => {
          if (field.hide) {
            return null;
          };

          switch (field.fieldName) {
            case 'pk':
              if (
                field.linked &&
                (
                  checkHasPermission(user, viewPermission) ||
                  checkHasPermission(user, changePermission)
                )
              ) {
                return (
                  <td className="all-list-scrollable-area-id-container">
                    <div className="all-list-scrollable-area-table-item-common all-list-scrollable-area-id-container">
                      <Link
                        to={`${pushPathname}/${item[pushPathId]}/${actions.includes('Detail') ? '' : 'edit/' }`}
                        className="all-list-scrollable-area-text-common all-list-scrollable-area-clickable-field"
                      >
                        {item.pk || '-'}
                      </Link>
                    </div>
                  </td>
                );
              }
              return (
                <td
                  index={`${index}-${field.fieldName}`}
                  className="all-list-scrollable-area-id-container"
                >
                  <div className="all-list-scrollable-area-table-item-common all-list-scrollable-area-id-container">
                    <label className="all-list-scrollable-area-text-common all-list-scrollable-area-unclickable-field">
                      {item[field.fieldName] || '-'}
                    </label>
                  </div>
                </td>
              );
            case 'name':
            case 'templateName':
              if (field.customerLink && item["customerId"] && !item["customerIsReset"]) {
                return (
                  <td className="all-list-scrollable-area-name">
                    <CustomLinkableName
                      to={`/customers/${item["customerId"]}/`}
                      text={item[field.fieldName]}
                    />
                  </td>
                )
              }
              if (
                field.linked === false ||
                !checkHasPermission(
                  user,
                  actions.includes('Detail') ? viewPermission : changePermission,
                )
              ) {
                return (
                  <td className="all-list-scrollable-area-name">
                    <div className="all-list-scrollable-area-name all-list-scrollable-area-table-item-common">
                      <label className="all-list-scrollable-area-text-common list-new-line">
                        {item[field.fieldName] || '-'}
                      </label>
                    </div>
                  </td>
                );
              }
              return (
                <td className="all-list-scrollable-area-name">
                  <CustomLinkableName
                    to={`${pushPathname}/${item[pushPathId]}/${actions.includes('Detail') ? '' : 'edit/'
                      }`} //need change link
                    text={item[field.fieldName]}
                    openNewTab={openNewTab}
                  />
                </td>
              );
            case 'couponDisplayId':
              const couponDisplayId = item["couponDisplayId"] || "";
              if (couponDisplayId.startsWith("For use: ")) {
                const forUseCoupon = couponDisplayId.split(",")?.[0];
                const forUseCouponId = forUseCoupon?.replace("For use: ", "");
                if (forUseCouponId) {
                  const otherDisplay = couponDisplayId.replace(forUseCoupon, "");
                  return (
                    <td>
                      <div className="all-list-scrollable-area-table-item-common">
                        <label className="all-list-scrollable-area-text-common list-new-line">
                          For use: <a
                            href={`/coupons/${item["templateId"]}/${forUseCouponId}/edit/`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >{forUseCouponId}</a>{otherDisplay}
                        </label>
                      </div>
                    </td>
                  );
                }
              }
              return (
                <td>
                  <div className="all-list-scrollable-area-table-item-common">
                    <label className="all-list-scrollable-area-text-common list-new-line">
                      {couponDisplayId || '-'}
                    </label>
                  </div>
                </td>
              );
            case 'membershipId':
              if (field.linked && item["customerId"] && !item["customerIsReset"]) {
                return (
                  <td className="all-list-scrollable-area-name">
                    <CustomLinkableName
                      to={`/customers/${item["customerId"]}/`}
                      text={item[field.fieldName]}
                    />
                  </td>
                )
              }
              return (
                <td>
                  <div className="all-list-scrollable-area-table-item-common">
                    <label
                      className="all-list-scrollable-area-text-common list-new-line"
                    >
                      {item[field.fieldName] || '-'}
                    </label>
                  </div>
                </td>
              )
            case 'status':
            case 'displayStatus':
              return (
                <td className="common-status-area all-list-scrollable-area-table-item-common">
                  {CustomStatusTagFromText(item[field.fieldName])}
                </td>
              );
            case 'coverPhoto':
            case 'icon':
            case 'displayImage':
              return (
                <>
                  {item[field.fieldName] ? (
                    <td className="common-status-area">
                      <div style={{ padding: '20px 0px' }}>
                        <img
                          alt="cover"
                          className="base-display-item-photo"
                          src={item[field.fieldName]}
                          style={{
                            width: 100,
                            height: 100,
                            border: '1px solid #DADADA',
                          }}
                          onClick={
                            field.enlarge
                              ? () => {
                                setEnlargeImage(item[field.fieldName]);
                              }
                              : () => { }
                          }
                        />
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div
                        className={`all-list-scrollable-area-table-item-common`}
                      >
                        <label
                          className={`all-list-scrollable-area-text-common list-new-line`}
                        >
                          {'-'}
                        </label>
                      </div>
                    </td>
                  )}
                </>
              );
            case 'codeDisplayImage':
              return (
                <>
                  {item?.codeDisplayImage ? (
                    <td className="common-status-area">
                      <div style={{ padding: '20px 0px' }}>
                        <QRCodeCollapse {...item} />
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div
                        className={`all-list-scrollable-area-table-item-common`}
                      >
                        <label
                          className={`all-list-scrollable-area-text-common list-new-line`}
                        >
                          {'-'}
                        </label>
                      </div>
                    </td>
                  )}
                </>
              );
            case 'order':
              return (
                <DisplayOrderTableData
                  item={item}
                  onDone={onOrderChangedByEdit}
                  editable={
                    checkHasPermission(user, changePermission) &&
                    (searchQuery['sort']?.indexOf('displayPriority') === 0 ||
                      (field.orderField === 'displayPriority' &&
                        searchQueryKeyListEmptyOrOnlyPage))
                  }
                />
              );
            case 'displayMessageName':
              const deeplink = field?.deeplink && field?.deeplink(item);
              if (
                field.linked === false ||
                !deeplink ||
                !checkHasPermission(
                  user,
                  actions.includes('Detail') ? viewPermission : changePermission,
                )
              ) {
                return (
                  <td className="all-list-scrollable-area-name">
                    <div className="all-list-scrollable-area-name all-list-scrollable-area-table-item-common">
                      <label className="all-list-scrollable-area-text-common list-new-line">
                        {item[field.fieldName] || '-'}
                      </label>
                    </div>
                  </td>
                );
              }
              return (
                <td className="all-list-scrollable-area-name">
                  <CustomLinkableName
                    to={deeplink}
                    text={item[field.fieldName]}
                  />
                </td>
              );
            case 'stampProgress':
              return (
                <td className="all-list-scrollable-area-name">
                  <div className="all-list-scrollable-area-name all-list-scrollable-area-table-item-common">
                    <label className="all-list-scrollable-area-text-common list-new-line">
                      {`${item[field.fieldName] || 0}%`}
                    </label>
                    <div className='stamp-progress-outline'>
                      <div className='stamp-progress-fill' style={{ width: `${item[field.fieldName] || 0}%` }} />
                    </div>
                  </div>
                </td>
              )
            default:
              if (field.isRichText) {
                return (
                  <td>
                    <div className="all-list-scrollable-area-table-item-common">
                      <label className={"all-list-scrollable-area-text-common list-new-line"}>
                        <CustomRichTextViewer
                          initialValue={
                            // eslint-disable-next-line no-useless-escape
                            item[field.fieldName] || '\\-'
                          }
                        />
                      </label>
                    </div>
                  </td>
                );
              } else {
                return (
                  <td>
                    <div className={`all-list-scrollable-area-table-item-common`} >
                      <LabelWithToolTips
                        title={item[field.fieldName] || '-'}
                        className={"all-list-scrollable-area-text-common list-new-line"}
                      />
                    </div>
                  </td>
                );
              }
          }
        })}
        {hideActions ? null : (
          <td className="all-list-scrollable-area-actions all-list-scrollable-area-table-item-common">
            {useCustomCommonActions ? (
              customCommonActions(item)
            ) : (
              <ActionsDropdownForItem
                object={item}
                actions={getNormalActions(item)}
                otherActions={otherActions(item)}
              />
            )}
          </td>
        )}
      </tr>
    );
  };

  const renderTableBody = () => {
    if (status === APIStatus.calling) {
      return (
        <tbody>
          <tr>
            <td colSpan={hideActions ? fields.length + 1 : fields.length + 2}>
              <Loading />
            </td>
          </tr>
        </tbody>
      );
    }
    if (dataList.length <= 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={hideActions ? fields.length + 1 : fields.length + 2}>
              <NoDataPage />
            </td>
          </tr>
        </tbody>
      );
    }
    if (
      sortable &&
      checkHasPermission(user, changePermission) &&
      (searchQuery['sort']?.indexOf('displayPriority') === 0 ||
        (fields.filter((field) => field.orderField === 'displayPriority')
          .length > 0 &&
          searchQueryKeyListEmptyOrOnlyPage))
    ) {
      return (
        <SortableTableBody
          dataList={dataList}
          disabled={sortDisabled}
          onSortEnd={onSortEnd}
          renderRowData={(item) => renderRowData(item)}
        />
      );
    }
    return <tbody>{dataList.map((item, index) => renderRowData(item))}</tbody>;
  };

  return (
    <div
      className="campaign-list-section common-table-overflow "
      key={`${model}-list`}
    >
      <PerfectScrollbar
        onScrollLeft={() => {
          setTableEndReach(false);
          console.log('onScrollLeft');
        }}
        onScrollRight={() => {
          setTableStartReach(false);
          console.log('onScrollRight');
        }}
        onXReachStart={() => {
          setTableStartReach(true);
          console.log('onXReachStart');
        }}
        onXReachEnd={() => {
          setTableEndReach(true);
          console.log('onXReachEnd');
        }}
      >
        <table className={`all-list-table ${customClassName}`}>
          <thead>{getTableTitles()}</thead>
          {renderTableBody()}
        </table>
      </PerfectScrollbar>
        {!tableStartReach && showTableLeftShadow ?
          <div className="table-shadow-left" style={ dataList.length > 0 ? {} : {height: '80px'}} /> : null}
        {!tableEndReach && showTableRightShadow ? 
          <div className="table-shadow-right" style={ dataList.length > 0 ? {} : {height: '80px'}} /> : null}
      {dataList.length > 0 ? (
        <div className="all-list-scrollable-area-pagination">
          <CustomPagination
            initPage={currentPage}
            pageSize={totalPage}
            pageChange={(page) => {
              history.push({
                pathname: location.pathname,
                hash: location.hash,
                search: queryString.stringify({
                  ...queryString.parse(location.search),
                  ...{
                    page: page + 1,
                  },
                }),
              });
            }}
          />
        </div>
      ) : null}

      <DeletePrompt
        title={deleteInfo.title}
        relatedName={deleteInfo.relatedName}
        relatedSections={deleteInfo.relatedSections}
        data={operatedItem}
        show={showPrompt}
        onClose={() => {
          setShowPrompt(false);
          setOperatedItem(null);
        }}
        onConfirm={() => {
          setShowPrompt(false);
          dispatch({
            type: `${model}/updateState`,
            payload: { checkedList: [operatedItem] },
          });
          dispatch(
            createAction(actionDispatchType?.delete || `${model}/delete`)({
              afterAction: () => {
                history.push({
                  pathname: location.pathname,
                  hash: location.hash,
                  search: queryString.stringify({
                    ...queryString.parse(location.search),
                    page: 1,
                  }),
                });
              },
            }),
          );
        }}
      />
      <PreviewImage
        show={enlargeImage ? true : false}
        onClose={() => {
          setEnlargeImage(null);
        }}
        imageUrl={enlargeImage}
      />
    </div>
  );
}

export default BaseListContainer;
